import React from "react";
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Card,
  CardContent,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import { themeColors } from "../../css/themeConfig";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import ButtonStyled from "../../general/ButtonStyled";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: (props) => themeColors[props.themeName].headerColor,
      borderRadius: 8,
    },
  },
  dialogTitle: {
    backgroundColor: (props) => themeColors[props.themeName].headerColor,
    color: (props) => themeColors[props.themeName].color,
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogContent: {
    backgroundColor: "#f1f1f1",
    padding: theme.spacing(3),
  },
  dialogActions: {
    backgroundColor: "#f1f1f1",
    padding: theme.spacing(2),
  },
  primaryButton: {
    backgroundColor: (props) => themeColors[props.themeName].headerColor,
    color: (props) => themeColors[props.themeName].color,
    "&:hover": {
      backgroundColor: (props) => themeColors[props.themeName].headerColor,
      opacity: 0.8,
    },
  },
  cancelButton: {
    color: (props) => themeColors[props.themeName].headerColor,
  },
  closeButton: {
    color: (props) => themeColors[props.themeName].color,
  },
  card: {
    marginTop: theme.spacing(2),
    backgroundColor: "white",
  },
  cardContent: {
    padding: theme.spacing(2),
  },
}));

const ConfirmationModal = ({ open, handleClose, handleConfirm, message }) => {
  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";
  const classes = useStyles({ themeName });

  return (
    <Dialog open={open} onClose={handleClose} className={classes.dialog}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h5">Confirmation d'envoi</Typography>
        <IconButton onClick={handleClose} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Alert severity="info">
          <AlertTitle>
            {" "}
            <strong>Info</strong>
          </AlertTitle>
          Vous êtes sur le point d'envoyer le message aux destinataires
          sélectionnés, veuillez confirmer l'envoi en cliquant sur le bouton{" "}
          <strong>"Envoyer"</strong>.
        </Alert>
        <Typography variant="h6" style={{ marginTop: 16 }}>
          Aperçu du message :
        </Typography>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </CardContent>
        </Card>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={handleClose} className={classes.cancelButton}>
          Annuler
        </Button>
        <ButtonStyled
                  onClick={handleConfirm}
                  variant="contained"
                  color="successDarkBtn"
                >
                  Envoyer
                </ButtonStyled>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
